import { classNames } from 'shared/lib/classNames/classNames';
import { ReactNode, SyntheticEvent, useState } from 'react';
import { Collapse } from 'react-collapse';
import { Text, TextSize } from '../Text/Text';
import { APIProductTypes } from 'app/api/APITypes';
import Icon from 'shared/assets/icons/selector-arrow.svg';
import cls from './Selector.module.scss';

interface SelectorProps {
    options: { name: string, filter?: APIProductTypes }[],
    callback?: any,
}

export const Selector = ({ options, callback}: SelectorProps) => {
    const [pickedOption, setPickedOption] = useState(options[0].name);
    const [isOpened, setIsOpened] = useState(false);

    return (
        <>
            <div className={classNames(cls.header, { [cls.active]: isOpened })} onClick={() => setIsOpened(!isOpened)}>
                <Text className={cls.mainTitle} color="#353850" size={TextSize.text_16}>
                    {pickedOption}
                </Text>
                <Icon className={classNames(cls.icon, { [cls.activeIcon]: isOpened })} />
            </div>
            <Collapse isOpened={isOpened}>
                <div className={cls.content}>
                    {
                        options.map(({ name, value, filter }: any, index: number) => {
                            return (
                                <div className={cls.option} onClick={() => {
                                    setPickedOption(options[index].name);
                                    setIsOpened(!isOpened);
                                    if (callback) {
                                        callback(value, filter, index);
                                    }
                                }} key={index}>
                                <Text className={cls.mainTitle} color="#353850" size={TextSize.text_16}>{name}</Text>
                                </div>
                            )
                        })
                    }
                </div>
            </Collapse>
        </>
    )
};
